/**
 * product-qa.js
 * StonyLab Product Q&A widget
 * Handles: question listing, question submission, pagination
 * Matches the reference branch product-reviews.js patterns
 */
(function () {
  'use strict';

  // ==================== State per product ====================
  var widgets = {};

  // ==================== Init ====================
  function init() {
    var els = document.querySelectorAll('.product-qa-section');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var pid = el.getAttribute('data-product-id');
      var api = el.getAttribute('data-api-base');
      if (pid && api) {
        initWidget(pid, api, el);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function initWidget(pid, api, el) {
    // Strip trailing slash to avoid double slash in URL construction
    api = api.replace(/\/+$/, '');
    widgets[pid] = {
      page: 1,
      pageSize: parseInt(el.getAttribute('data-page-size')) || 10,
      total: 0,
      productHandle: el.getAttribute('data-product-handle') || '',
      productTitle: el.getAttribute('data-product-title') || '',
      shopDomain: el.getAttribute('data-shop-domain') || '',
      answerAvatarUrl: el.getAttribute('data-answer-avatar-url') || ''
    };
    loadQuestions(pid, api, 1);
    bindAskButton(pid, el);
    bindForm(pid, api, el);
  }

  // ==================== Load Questions ====================
  function loadQuestions(pid, api, page) {
    var container = document.getElementById('qa-list-' + pid);
    if (!container) return;

    // Lock container height before replacing content to prevent layout collapse
    // and unwanted scroll position jumps during pagination
    var currentHeight = container.offsetHeight;
    container.style.minHeight = currentHeight + 'px';
    container.innerHTML = '<div class="qa-loading">Loading questions...</div>';

    var qs = widgets[pid];
    var productQuery = 'productId=' + encodeURIComponent(pid);
    if (qs.productHandle) {
      productQuery += '&productHandle=' + encodeURIComponent(qs.productHandle);
    }
    return fetch(api + '/questions?' + productQuery + '&page=' + page + '&size=' + qs.pageSize)
      .then(function (r) { return r.json(); })
      .then(function (r) {
        var questions = (r.code === 200 && r.data) ? r.data : [];
        if (questions.length === 0 && page === 1) {
          qs.total = 0;
          qs.page = 1;
          renderQuestions(pid, api, [], 1, 0);
          return;
        }
        return fetch(api + '/questions/count?' + productQuery)
          .then(function (cr) { return cr.json(); })
          .then(function (cr) {
            var total = (cr.code === 200 && cr.data) ? (cr.data.count || 0) : getFallbackTotal(qs, questions, page);
            qs.total = total;
            qs.page = page;
            renderQuestions(pid, api, questions, page, total);
          })
          .catch(function () {
            var total = getFallbackTotal(qs, questions, page);
            qs.total = total;
            qs.page = page;
            renderQuestions(pid, api, questions, page, total);
          });
      })
      .catch(function () {
        // Show empty state instead of hiding — keep Ask button available
        widgets[pid].total = 0;
        widgets[pid].page = 1;
        renderQuestions(pid, api, [], 1, 0);
      });
  }

  // ==================== Render Questions ====================
  function renderQuestions(pid, api, questions, page, total) {
    var container = document.getElementById('qa-list-' + pid);
    var countEl = document.getElementById('qa-count-' + pid);
    var emptyEl = document.getElementById('qa-empty-' + pid);

    if (!container) return;

    // Update count
    if (countEl) {
      countEl.textContent = total > 0 ? '(' + total + (total === 1 ? ' question' : ' questions') + ')' : '';
    }

    if (questions.length === 0 && page === 1) {
      container.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      // Show section even when 0 questions — user wants the module visible
      var section = document.getElementById('product-qa-' + pid);
      if (section) section.style.display = '';
      container.style.minHeight = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    var answerAvatarUrl = widgets[pid] ? widgets[pid].answerAvatarUrl : '';
    var html = '<div class="qa-cards">';
    for (var i = 0; i < questions.length; i++) {
      html += cardQuestion(questions[i], answerAvatarUrl);
    }
    html += '</div>';
    html += renderPagination(pid, page, total);

    container.innerHTML = html;
    // Release height lock after new content is rendered
    container.style.minHeight = '';
    bindPagination(pid, api, page, total);
  }

  function getFallbackTotal(qs, questions, page) {
    var visibleCount = (page - 1) * qs.pageSize + questions.length;
    return Math.max(qs.total || 0, visibleCount);
  }

  // ==================== Question Card ====================
  function cardQuestion(q, answerAvatarUrl) {
    var date = q.createdAt ? formatDate(q.createdAt) : '';
    var name = q.askerName ? q.askerName.trim() : '';
    var ini = 'A';
    var disp = 'Anonymous';
    if (name) {
      disp = esc(name);
      var parts = name.split(/\s+/);
      ini = parts[0].charAt(0).toUpperCase();
      if (parts.length > 1) {
        ini += parts[parts.length - 1].charAt(0).toUpperCase();
      }
    }

    var answerHtml = '';
    if (q.answerBody) {
      var aDate = q.answeredAt ? formatDate(q.answeredAt) : '';
      var answerAvatar = answerAvatarUrl
        ? '<img class="qa-card__answer-avatar" src="' + esc(answerAvatarUrl) + '" alt="" width="26" height="26">'
        : 'A';
      answerHtml = '<div class="qa-card__answer">' +
        '<div class="qa-card__answer-header">' +
          '<span class="qa-card__answer-label">' + answerAvatar + '</span>' +
          '<span class="qa-card__answer-author">' + esc(q.answererName || 'StonyLab') + '</span>' +
          (aDate ? '<span class="qa-card__date-inline">' + aDate + '</span>' : '') +
        '</div>' +
        '<p class="qa-card__answer-body">' + esc(normalizeLineBreaks(q.answerBody)) + '</p>' +
      '</div>';
    }

    return '<div class="qa-card">' +
      '<div class="qa-card__header">' +
        '<div class="qa-card__user">' +
          '<div class="qa-card__avatar">' + esc(ini) + '</div>' +
          '<div class="qa-card__author-info">' +
            '<span class="qa-card__author">' + disp + '</span>' +
            (date ? '<span class="qa-card__date-inline">' + date + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<span class="qa-card__label">Q</span>' +
      '</div>' +
      '<p class="qa-card__body">' + esc(normalizeLineBreaks(q.questionBody || '')) + '</p>' +
      answerHtml +
    '</div>';
  }

  // ==================== Pagination ====================
  function renderPagination(pid, page, total) {
    var qs = widgets[pid];
    if (!qs) return '';
    var totalPages = Math.ceil(total / qs.pageSize);
    if (totalPages <= 1) return '';

    var html = '<div class="qa-pagination">';
    // Prev
    if (page > 1) {
      html += '<button class="qa-pg-btn" data-pg="' + (page - 1) + '">&laquo;</button>';
    }
    // Page numbers
    var start = Math.max(1, page - 2);
    var end = Math.min(totalPages, page + 2);
    if (start > 1) {
      html += '<button class="qa-pg-btn" data-pg="1">1</button>';
      if (start > 2) html += '<span class="qa-pg-dots">...</span>';
    }
    for (var p = start; p <= end; p++) {
      html += '<button class="qa-pg-btn' + (p === page ? ' qa-pg-btn--active' : '') + '" data-pg="' + p + '">' + p + '</button>';
    }
    if (end < totalPages) {
      if (end < totalPages - 1) html += '<span class="qa-pg-dots">...</span>';
      html += '<button class="qa-pg-btn" data-pg="' + totalPages + '">' + totalPages + '</button>';
    }
    // Next
    if (page < totalPages) {
      html += '<button class="qa-pg-btn" data-pg="' + (page + 1) + '">&raquo;</button>';
    }
    html += '</div>';
    return html;
  }

  function bindPagination(pid, api, page, total) {
    var container = document.getElementById('qa-list-' + pid);
    if (!container) return;
    var btns = container.querySelectorAll('.qa-pg-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        e.preventDefault();
        var pg = parseInt(this.getAttribute('data-pg'));
        if (!isNaN(pg)) {
          widgets[pid].page = pg;
          scrollToQAHeader(pid);
          loadQuestions(pid, api, pg).then(function () {
            requestAnimationFrame(function () {
              scrollToQAHeader(pid);
            });
          });
        }
      });
    }
  }

  function scrollToQAHeader(pid) {
    var navButton = document.querySelector('.custom-scroll-nav__btn[data-selector="#questions-answers"]');
    if (navButton) {
      // Reuse Q&A navigation, including its offset and sticky-header correction.
      navButton.click();
      return;
    }

    var section = document.getElementById('product-qa-' + pid);
    var target = section ? section.querySelector('.qa-header') : null;
    if (!target || !target.scrollIntoView) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    } catch (e) {
      target.scrollIntoView();
    }
  }

  // ==================== Ask Button ====================
  function bindAskButton(pid, el) {
    var btn = el.querySelector('.qa-ask-btn');
    var formContainer = document.getElementById('qa-form-container-' + pid);
    if (!btn || !formContainer) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = formContainer.classList.contains('qa-form-container--open');
      if (isOpen) {
        formContainer.classList.remove('qa-form-container--open');
        btn.textContent = 'Ask a Question';
        btn.classList.remove('qa-ask-btn--cancel');
      } else {
        formContainer.classList.add('qa-form-container--open');
        btn.textContent = 'Cancel';
        btn.classList.add('qa-ask-btn--cancel');
        var firstInput = formContainer.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
      }
    });

    var cancelBtn = formContainer.querySelector('.qa-form__cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        formContainer.classList.remove('qa-form-container--open');
        btn.textContent = 'Ask a Question';
        btn.classList.remove('qa-ask-btn--cancel');
      });
    }
  }

  // ==================== Form Handling ====================
  function bindForm(pid, api, el) {
    var form = document.getElementById('qa-form-' + pid);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      clearFormErrors(form);
      var msgEl = document.getElementById('qa-form-message-' + pid);
      if (msgEl) {
        msgEl.textContent = '';
        msgEl.className = 'qa-form__message';
      }

      var nameInput = form.querySelector('[name="qa-name"]');
      var emailInput = form.querySelector('[name="qa-email"]');
      var bodyInput = form.querySelector('[name="qa-body"]');

      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var body = bodyInput ? bodyInput.value.trim() : '';

      var hasError = false;
      if (!name) {
        showFieldError(nameInput, 'Please enter your name.');
        hasError = true;
      } else if (name.length > 100) {
        showFieldError(nameInput, 'Name must be 100 characters or fewer.');
        hasError = true;
      }
      if (!email) {
        showFieldError(emailInput, 'Please enter your email.');
        hasError = true;
      } else if (!isValidEmail(email)) {
        showFieldError(emailInput, 'Please enter a valid email address.');
        hasError = true;
      } else if (email.length > 200) {
        showFieldError(emailInput, 'Email must be 200 characters or fewer.');
        hasError = true;
      }
      if (!body) {
        showFieldError(bodyInput, 'Please enter your question.');
        hasError = true;
      } else if (body.length > 2000) {
        showFieldError(bodyInput, 'Question must be 2000 characters or fewer.');
        hasError = true;
      }

      if (hasError) return;

      var submitBtn = form.querySelector('.qa-form__submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      var qs = widgets[pid];
      var payload = {
        productId: pid,
        name: name,
        email: email,
        body: body,
        productHandle: qs ? qs.productHandle : '',
        productTitle: qs ? qs.productTitle : '',
        shopDomain: qs ? qs.shopDomain : '',
        recaptchaToken: ''
      };

      fetch(api + '/questions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (r) {
          if (r.code === 200) {
            form.reset();
            if (msgEl) {
              msgEl.textContent = 'Your question has been submitted successfully! Our team will review and answer it soon.';
              msgEl.className = 'qa-form__message qa-form__message--success';
            }
            setTimeout(function () {
              loadQuestions(pid, api, 1);
            }, 2000);
          } else {
            if (msgEl) {
              msgEl.textContent = r.message || 'Failed to submit question. Please try again.';
              msgEl.className = 'qa-form__message qa-form__message--error';
            }
          }
        })
        .catch(function () {
          if (msgEl) {
            msgEl.textContent = 'Network error. Please check your connection and try again.';
            msgEl.className = 'qa-form__message qa-form__message--error';
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Question';
          }
        });
    });
  }

  function showFieldError(input, message) {
    if (!input) return;
    var field = input.closest('.qa-form__field');
    if (field) {
      field.classList.add('qa-form__field--error');
      var errorEl = field.querySelector('.qa-form__error');
      if (errorEl) {
        errorEl.textContent = message;
      } else {
        var span = document.createElement('span');
        span.className = 'qa-form__error';
        span.textContent = message;
        field.appendChild(span);
      }
    }
  }

  function clearFormErrors(form) {
    var fields = form.querySelectorAll('.qa-form__field--error');
    for (var i = 0; i < fields.length; i++) {
      fields[i].classList.remove('qa-form__field--error');
    }
    var errors = form.querySelectorAll('.qa-form__error');
    for (var j = 0; j < errors.length; j++) {
      errors[j].textContent = '';
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ==================== Hide Section ====================
  function hideQASection(pid) {
    var section = document.getElementById('product-qa-' + pid);
    if (section) {
      section.style.display = 'none';
    }
  }

  // ==================== Helpers ====================
  function formatDate(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var yyyy = d.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  function normalizeLineBreaks(s) {
    if (s == null) return '';
    return String(s)
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/\\r\\n/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\/n/g, '\n');
  }

})();
